// src/store/notificationStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { io } from 'socket.io-client';
import { ENVIROMENT } from '../../../v2-config/constants/enviroments.constant';

const useNotificationStore = create(
	persist(
		(set, get) => ({
			token: null,
			socket: null,
			isConnected: false,
			notifications: [],
			notificationCount: 0,
			orderCount: 0,
			claimsCount: 0,
			quotationCount:0,
			preorderCount: 0,
			error: null,

			// Almacenar el token
			setToken: (token) => {
				set({ token });
				get().initSocket(token);
			},

			// Limpiar el token (logout)
			clearToken: () => {
				get().cleanupSocket();
				set({ token: null });
			},

			// Inicializar la conexión del socket
			initSocket: (token) => {
				// Primero limpiar si ya existe una conexión
				get().cleanupSocket();

				if (!token) return;

				const socketInstance = io(ENVIROMENT.WEB_SOCKET, {
					transports: ['websocket'],
					auth: { token: token },
				});

				// Eventos de conexión
				socketInstance.on('connect', () => {
					console.log('Socket connected');
				});

				socketInstance.on('authorization-status', (status) => {
					console.log('Auth status received:', status);
					if (status === true) {
						set({ isConnected: true });
						console.log('Authorization successful');

						// Solicitar el contador de notificaciones iniciales
						socketInstance.emit('get-count-notifications', {});
					} else {
						set({ error: status.message || 'Authorization failed' });
						console.error('Authorization failed:', status.message);
						socketInstance.disconnect();
					}
				});

				socketInstance.on('disconnect', () => {
					set({ isConnected: false });
					console.log('Socket disconnected');
				});

				socketInstance.on('connect_error', (err) => {
					set({ error: `Connection error: ${err.message}` });
					console.error('Connection error:', err);
				});

				// Eventos de notificaciones
				// socketInstance.on('new-notification', (notification) => {
				// 	set((state) => ({
				// 		notifications: [notification, ...state.notifications],
				// 		notificationCount: state.notificationCount + 1,
				// 	}));
				// 	console.log('New notification received:', notification);
				// });

				socketInstance.on('new-notification', (notification) => {
					set((state) => {
						// Verificar si ya existe la notificación por ID
						const exists = state.notifications.some((n) => n._id === notification._id);

						// Si ya existe, no la agregamos de nuevo
						if (exists) {
							return state;
						}

						return {
							notifications: [notification, ...state.notifications],
							// notificationCount: state.notificationCount + 1,
						};
					});
					console.log('New notification received:', notification);
				});

				socketInstance.on('count-notifications', (data) => {
					set({ notificationCount: data.unreadNotifications, orderCount: data.orders, claimCount: data.claims, quotationCount: data.quotations, preorderCount: data.preorders || 0 });
					console.log('Notification count:', data);
				});

				socketInstance.on('receive-notifications', (data) => {
					set({ notifications: data });
					console.log('Received notifications:', data);
				});

				set({ socket: socketInstance });
			},

			// Limpiar la conexión del socket
			cleanupSocket: () => {
				const { socket } = get();
				if (socket) {
					socket.disconnect();
					set({ socket: null, isConnected: false });
				}
			},

			// Obtener todas las notificaciones
			getNotifications: () => {
				const { socket, isConnected } = get();
				if (socket && isConnected) {
					socket.emit('get-notification', {});
				}
			},

			// Marcar una notificación como vista
			markAsSeen: (notificationId) => {
				const { socket, isConnected } = get();
				if (socket && isConnected) {
					socket.emit('set-seen', { id: notificationId, seen: true });
				}
			},

			// Obtener el contador de notificaciones
			getNotificationCount: () => {
				const { socket, isConnected } = get();
				if (socket && isConnected) {
					socket.emit('get-count-notifications', {});
				}
			},

			// Reintentar la conexión
			retryConnection: () => {
				const { socket } = get();
				if (socket) {
					socket.emit('retry-authorization');
				}
			},
		}),
		{
			name: 'notification-storage', // nombre para localStorage
			partialize: (state) => ({ token: state.token }), // solo persiste el token
		},
	),
);

export default useNotificationStore;
